import axios from 'axios';
import jsonp from 'jsonp';

export default {
  install(Vue, options) {

    function axiosReq(request, callback) {
      console.log(request.url);
      axios(request).then(function (response) {
        console.log(response);
        callback(response.data);
      }).catch(function (error) {
        callback({ Success: false, Data: error });
      });
    }

    //Vue.prototype.$GetTimezone = function (lat, lng, callback) {
    //    callback(false, { time: this.$moment().format("YYYY-MM-DD HH:mm")});
    //    var url = "http://api.geonames.org/timezoneJSON";
    //    var options = '';
    //    options += '?';
    //    options += 'lat=' + lat;
    //    options += '&';
    //    options += 'lng=' + lng;
    //    options += '&';
    //    options += 'lang=he';
    //    options += '&';
    //    options += 'username=getnet';

    //    url = url + options;

    //    var req = {
    //        url: url,
    //        method: 'get',
    //        responseType: 'json'
    //    };

    //    jsonp(url, {}, function (error, data) {
    //        callback(error, data);
    //    });
    //}

    //Vue.prototype.$GetWeather = function (lat, lng, callback) {
    //    callback(false, { weatherObservation: { clouds: 'מעונן חלקית' } });
    //    var url = "http://api.geonames.org/findNearByWeatherJSON";
    //    var options = '';
    //    options += '?';
    //    options += 'lat=' + lat;
    //    options += '&';
    //    options += 'lng=' + lng;
    //    options += '&';
    //    options += 'lang=he';
    //    options += '&';
    //    options += 'username=getnet';

    //    url = url + options;

    //    var req = {
    //        url: url,
    //        method: 'get',
    //        responseType: 'json'
    //    };

    //    jsonp(url, {}, function (error, data) {
    //        callback(error, data);
    //    });
    //}

    Vue.prototype.$GetWeatherXXXXXXXX = function (apiKey, lat, lng, callback) {
      var url = "https://api.darksky.net/forecast/";
      var options = '';
      options += apiKey + '/';
      options += lat + ',' + lng;
      options += '?';
      options += 'units=uk';
      options += '&';
      options += 'lang=en';
      options += '&';
      options += 'exclude=flags,summary,daily,minutely,hourly,alerts';

      url = url + options;

      var req = {
        url: url,
        method: 'get',
        responseType: 'json'
      };

      jsonp(url, {}, function (error, data) {
        callback(error, data);
      });
    }

    Vue.prototype.$GetWeather = function (apiKey, lat, lng, callback) {
      let error = 'GetWeather Api is blocked !!';
      let data = null;

      error = null;
      data = {
        currently: {
          time: 0,
          summary: 'No Data',
          temperature: 0
        }
      };
      callback(error, data);
    }

    Vue.prototype.$GetPlace = function (placeId, latlng, callback) {
      var url = "https://maps.googleapis.com/maps/api/place/details/json?";

      url = url + "placeid=" + placeId;
      url = url + "&key=AIzaSyBoTa88_jMgJnMFJRiNzovZjTprk8MOxj0";
      url = url + "&language=he";
      var req = {
        url: url,
        method: 'get',
        responseType: 'json'
      };

      axios(req).then(function (response) {
        callback({ success: true, data: response });
      }).catch(function (error) {
        callback({ success: false, data: error });
      });
    }

    //Vue.prototype.$GetPlaceName = function (latlng, callback) {
    //    var url = "https://maps.googleapis.com/maps/api/geocode/json?";
    //    url = url + "latlng=" + latlng.lat + ',' + latlng.lng;
    //    url = url + "&key=AIzaSyBoTa88_jMgJnMFJRiNzovZjTprk8MOxj0";
    //    url = url + "&language=he";

    //    var req = {
    //        url: url,
    //        method: 'get',
    //        responseType: 'json'
    //    };

    //    axios(req).then(function (response) {
    //        if (response.data.status == 'ZERO_RESULTS') {
    //            callback({ success: false, data: response.data.status });
    //        }
    //        else {
    //            callback({ success: true, data: response });
    //        }
    //    }).catch(function (error) {
    //        callback({ success: false, data: error });
    //    });
    //}

    Vue.prototype.$GetPlaceName = function (latlng, callback) {
      var geocoder = new google.maps.Geocoder;
      geocoder.geocode({ 'location': latlng }, function (results, status) {
        if (status === 'OK') {
          if (results[0]) {
            callback({ success: true, data: results[0] });
          } else {
            callback({ success: false, data: {} });
          }
        } else {
          callback({ success: false, data: status });
        }
      });
    }

    Vue.prototype.$GetPolygonCenter = function (lats, lngs, callback) {
      try {
        var center = { lat: 0, lng: 0 };
        if (lats.length > 0 && lngs.length > 0) {
          lats.sort();
          lngs.sort();
          var lowLat = lats[0];
          var highLat = lats[lats.length - 1];
          var lowLng = lngs[0];
          var highLng = lngs[lngs.length - 1];
          var latCenter = lowLat + ((highLat - lowLat) / 2);
          var lngCenter = lowLng + ((highLng - lowLng) / 2);
          center = { lat: latCenter, lng: lngCenter };
        }

        callback({ success: true, data: center });
      }
      catch (error) {
        callback({ success: false, data: error });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/api.js